var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"site-wrapper",class:{ 'site-sidebar--fold': true },attrs:{"element-loading-text":"拼命加载中"}},[(!_vm.loading)?[_c('main-navbar'),_vm._v(" "),_c('main-sidebar'),_vm._v(" "),_c('div',{staticClass:"site-content__wrapper",style:({ 'min-height': '0px' })},[_c('main-content')],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-652fafd6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/main.vue
// module id = 253
// module chunks = 1